<mat-toolbar
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  color="primary"
  [ngClass]="{
    'toolbar-style': true,
    'detail-toolbar-style': this.frame.routing.getCurrentConfig().designation !== AppService.Route_TicketList,
  }"
>
  @if (this.frame.routing.getCurrentConfig().designation === AppService.Route_TicketList) {
    <span class="toolbar-header"
      >{{ dataSource.filteredData ? dataSource.filteredData.length : 0 }} {{ res.get('Tickets') }}</span
    >
    @if (dataSource.visibleFilters.length > 0) {
      &nbsp;({{ res.get('List-Filtered') }}:
      @for (filter of dataSource.visibleFilters; track filter; let i = $index) {
        <span>
          {{ filter.displayText }}
          @if (i < dataSource.visibleFilters.length - 1) {
            ,
          }
        </span>
      }
      )
    }
    <span class="toolbar-spacer"></span>
    <button #searchMenuTrigger="matMenuTrigger" mat-icon-button [matMenuTriggerFor]="searchMenu" class="toolBarButton">
      <mat-icon [svgIcon]="res.svgName('Search-Image')"></mat-icon>
    </button>
    <mat-menu #searchMenu="matMenu" class="searchMenu">
      <div class="searchFormField">
        <abcAutoCompleteInput
          [placeHolder]="res.get('Search-PlaceHolder')"
          small="true"
          [panelBehaviour]="AutoCompletePanelBehaviour.OpenWhenTyping"
          [items]="allAutocompleteItems"
          (submit)="applyFilter($event)"
        ></abcAutoCompleteInput>
      </div>
    </mat-menu>
  } @else {
    <abcTileNavMenu>
      <tile (click)="this.ticketsService.navigateTo(AppService.Route_TicketList)"> {{ res.get('Tickets') }}</tile>
      <tile (click)="this.ticketsService.navigateTo(AppService.Route_TicketDetail)">
        {{ res.get('Tickets-Tasks') }}</tile
      >
    </abcTileNavMenu>
    <span class="toolbar-spacer"></span>
  }
  <button mat-icon-button class="toolBarButton" (click)="this.frame.lib.closeBottomSheet()">
    <mat-icon [svgIcon]="res.svgName('ExpandMore-Image')"></mat-icon>
  </button>
</mat-toolbar>

@if (!dataSource.isEmpty) {
  <div [@ticketsAnimation]="animationState">
    <router-outlet #routerOutlet="outlet" name="ticketsRouterOutlet"></router-outlet>
  </div>
} @else {
  <!-- ideal: font-size: 6vw; -->
  <div class="noDataPlaceHolder">&lt;{{ res.get('Tickets-NoData') }}&gt;</div>
}
